function setVisitors(data) {
	return {
		type: 'SET_VISITORS',
		payload: data,
	};
}

export { setVisitors };
